import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { RootState } from "../../../redux/store";
import { useQuery } from "@tanstack/react-query";
import i18n from "../../../i18n";
import { getImprovementPlanIndicators } from "../api/improvementPlanAPI";

type QueryFnTypeImprovementPlanIndicatorsType = typeof getImprovementPlanIndicators;

export const useImprovementPlanIndicators = (config?: QueryConfig<QueryFnTypeImprovementPlanIndicatorsType>) => {
    const filters = useSelector((state: RootState) => state.filters.improvementPlans.selectedFilters);
    const filterByUser = useSelector((state: RootState) => state.filters.improvementPlans.filterByCurrentUser ?? false);

    return useQuery<ExtractFnReturnType<QueryFnTypeImprovementPlanIndicatorsType>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["getImprovementPlanIndicators", filterByUser, filters, i18n.language],
        queryFn: () => getImprovementPlanIndicators(filters, filterByUser),
    });
}
